import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=90cfeec0&scoped=true&"
import script from "./Spinner.vue?vue&type=script&setup=true&lang=js&"
export * from "./Spinner.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=90cfeec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cfeec0",
  null
  
)

export default component.exports